import axios from "axios";
import settings from "../settings";

const newExtProductPrice = {
    id: "new",
    is_new: true,
    original_price: null,
    discount_price: null,
    ext_product: { name: null, weight: null },
    related_product: { id: null },
    shop: { id: null },
    ext_product_code: { id: null, ean: null }
};

let initialState = {
    productPriceHistory: [],
    loadingPriceHistory: false,
    loadingProductData: false,
    searchProductString: "",
    activeProduct: {},
    activeExtProductPrice: {},
    drawerOpen: false,
    requestSuccess: false,
    requestError: false,
    errorMessage: "",
    productPriceHistoryTableHeaders: [
        { text: "Name", value: "ext_product_name" },
        { text: "EAN", value: "ean" },
        { text: "Original price", align: "end", value: "original_price" },
        { text: "Discount price", align: "end", value: "discount_price" },
        { text: "Visited at", align: "center", value: "visited_at" },
        { text: "Shop name", value: "shop_name" }
    ]
};

let cancelDataRequest = null;
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchProductPriceHistory({ commit }) {
            await commit("setLoadingPriceHistory", true);

            if (cancelDataRequest) {
                cancelDataRequest();
            }

            const CancelToken = axios.CancelToken;

            try {
                let response = await axios.get(settings.api_url + "/ext-product-prices/", {
                    cancelToken: new CancelToken(c => {
                        cancelDataRequest = c;
                    })
                });

                if (response.status === 200) {
                    cancelDataRequest = null;
                    let data = response.data;
                    commit("setProductPriceHistory", data.data);
                    commit("setLoadingPriceHistory", false);
                }
            } catch (e) {
                console.log(e);
                commit("setLoadingPriceHistory", false);
                commit("setRequestError", true);
            }
        },
        async getProductData({ commit }, payload) {
            await commit("setLoadingProductData", true);

            try {
                let response = await axios.get(settings.api_url + `/ext-product/${payload.id}`);

                if (response.status === 200) {
                    let data = response.data.data;
                    commit("setActiveProduct", data);
                }
            } catch (error) {
                commit("setRequestError", true);
                console.error("Error fetching product data:", error);
            }

            await commit("setLoadingProductData", false);
        },
        async getProductPriceData({ commit }, payload) {
            await commit("setLoadingProductData", true);

            try {
                let response = await axios.get(settings.api_url + `/ext-product-price/${payload.id}`);

                if (response.status === 200) {
                    let data = response.data.data;
                    commit("setActiveExtProductPrice", data);
                }
            } catch (error) {
                commit("setRequestError", true);
                console.error("Error fetching product data:", error);
            }

            await commit("setLoadingProductData", false);
        },
        async saveActiveExtProductPriceChanges({ commit, dispatch, state }) {
            commit("setLoadingProductData", true);

            try {
                let response = await axios.put(
                    `${settings.api_url}/ext-product-price/${state.activeExtProductPrice.id}`,
                    state.activeExtProductPrice
                );

                if (response.status === 200) {
                    commit("setRequestSuccess", true);
                }
            } catch (error) {
                console.error("Error updating product data:", error);
                commit("setRequestError", true);
            }

            commit("setLoadingProductData", false);
        },
        async submitNewExtProductPrice({ commit, dispatch, state }) {
            commit("setLoadingProductData", true);
            try {
                let response = await axios.post(`${settings.api_url}/ext-product-price/`, state.activeExtProductPrice);

                if (response.status === 200) {
                    let { data } = response.data;
                    let newExtProductPriceId = data.new_ext_product_price_id;
                    await commit("updateActiveExtProductPriceField", { field: "id", value: newExtProductPriceId });
                }
            } catch (error) {
                console.error("Error updating product data:", error);
                commit("setRequestError", true);
            }

            commit("setLoadingProductData", false);
        },
        async deleteExtProductPrice({ commit, dispatch, state }) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setLoadingProductData", true);
            try {
                let response = await axios.delete(
                    settings.api_url + `/ext-product-price/${state.activeExtProductPrice.id}`
                );
                if (response && response.data.success === 1) {
                    await dispatch("fetchProductPriceHistory");
                    await commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    await commit("setRequestError", true);
                    await commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setRuleListLoading", false);
        }
    },
    mutations: {
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        setLoadingPriceHistory(state, bool) {
            state.loadingPriceHistory = bool;
        },
        setLoadingProductData(state, bool) {
            state.loadingProductData = bool;
        },
        setProductPriceHistory(state, value) {
            state.productPriceHistory = value;
        },
        setActiveProduct(state, value) {
            state.activeProduct = value;
        },
        setActiveExtProductPrice(state, value) {
            state.activeExtProductPrice = value;
        },
        updateActiveExtProductPriceField(state, { field, value }) {
            if (field.includes(".")) {
                const [objectKey, fieldName] = field.split(".");

                if (objectKey === "related_product") {
                    if (!state.activeExtProductPrice.related_product) {
                        state.activeExtProductPrice.related_product = {};
                    }
                    state.activeExtProductPrice.related_product[fieldName] = value;
                } else if (objectKey === "ext_product") {
                    if (!state.activeExtProductPrice.ext_product) {
                        state.activeExtProductPrice.ext_product = {};
                    }
                    state.activeExtProductPrice.ext_product[fieldName] = value;
                } else if (objectKey === "shop") {
                    if (!state.activeExtProductPrice.shop) {
                        state.activeExtProductPrice.shop = {};
                    }
                    state.activeExtProductPrice.shop[fieldName] = value;
                } else if (objectKey === "ext_product_code") {
                    if (!state.activeExtProductPrice.ext_product_code) {
                        state.activeExtProductPrice.ext_product_code = {};
                    }
                    state.activeExtProductPrice.ext_product_code[fieldName] = value;
                }
            } else {
                state.activeExtProductPrice[field] = value;
            }
        },
        addNewExtProductPrice(state) {
            state.activeExtProductPrice = JSON.parse(JSON.stringify(newExtProductPrice));
        }
    }
};
